import {Anchor, Group, Paper, Stack, Title} from '@mantine/core'
import {IconMapPin} from '@tabler/icons-react'

import {LocationList} from '../jobs/location-list'
import {LocationReadContent} from '../jobs/location-read-content'
import {googleMapsUrl} from './google-maps-link'
import type {DriverJob} from './schemas'

type DriverJobLocation = DriverJob['locations'][number]

type DriverJobLocationsProps = {
    locations: DriverJobLocation[]
}

export function DriverJobLocations({locations}: DriverJobLocationsProps) {
    if (locations.length === 0) {
        return null
    }

    return (
        <Paper withBorder p="md" radius="md">
            <Stack gap="md">
                <Title order={4}>Locations</Title>
                <LocationList
                    items={locations.map((location) => {
                        const mapsUrl =
                            location.latitude != null && location.longitude != null
                                ? googleMapsUrl(location.latitude, location.longitude)
                                : null

                        return (
                            <Stack key={location.id} gap="sm">
                                <Group gap="xs" align="center">
                                    <IconMapPin size={18} stroke={1.5} />
                                    <Title order={4} size="h4">
                                        {location.name}
                                    </Title>
                                </Group>
                                <LocationReadContent
                                    location={location}
                                    source="driver_job_location"
                                    layout="vertical"
                                    mapHeight={160}
                                    showName={false}
                                />
                                {mapsUrl ? (
                                    <Anchor
                                        href={mapsUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        size="sm"
                                    >
                                        Open in Google Maps
                                    </Anchor>
                                ) : null}
                            </Stack>
                        )
                    })}
                />
            </Stack>
        </Paper>
    )
}
